import React from 'react';
import { InstructionFormDetails } from '@supplierRegistration/routes/commonAfterFormPage/InstructionFormDetails';
import { NormalText } from '../../../Styles';
import MexicoFrictionlessAfterFormSpecialComponent from '@supplierRegistration/routes/supplierRegistrationProcess/afterFormPage/MexicoFrictionlessAfterFormSpecialComponent.tsx/MexicoFrictionlessAfterFormSpecialComponent';

export const MexicoFrictionlessFormDetails: InstructionFormDetails = {
  instructionsSubTitle: 'supplierValidation.afterRegister.mexicoFrictionless.nowYouAreRegistered',
  paymentInstructionsTitle: 'supplierValidation.afterRegister.paymentInst',
  paymentInstructionsLines: [
    {
      description: 'supplierValidation.afterRegister.beneficiaryName',
      value: 'nsKnox Technologies, Inc',
    },
    {
      description: 'supplierValidation.afterRegister.address',
      value: '135 Madison Ave, New York, NY 10016',
    },
    {
      description: 'supplierValidation.afterRegister.checkingAccount',
      value: '466007904549',
    },
    {
      description: 'supplierValidation.afterRegister.swift',
      value: 'supplierValidation.afterRegister.bofaWire.swiftValues',
    },
  ],
  paymentInstructionsAddress: {
    description: 'supplierValidation.afterRegister.bankAndAddress',
    value: (
      <NormalText>
        Bank of America,
        <br />
        222 Broadway,
        <br />
        New York, NY 10038
      </NormalText>
    ),
  },
  currencies: [],
  pleaseNote: {
    pleaseNoteItem: [
      'supplierValidation.afterRegister.mexicoFrictionless.pleaseNote',
      'supplierValidation.afterRegister.mexicoFrictionless.youMayBeAsked',
    ],
    hideInvoice: true,
  },
  showWireTransferWarningBox: {
    achWireTransfer: false,
    swiftWireTransfer: false,
  },
  extraInstructions: null,
  specialComponent: <MexicoFrictionlessAfterFormSpecialComponent />,
};
